export default class VerticalGallery{
	constructor(){
		const galleries = document.querySelectorAll(".verticalGallery");
		galleries.forEach(gallery=>{
			this.initialize(gallery);
		});
	}
	initialize(gallery){
		if(window.currentContext == "pc"){
			const main = gallery.querySelector(".verticalGallery__main");
			const images = main.querySelector(".verticalGallery__images");
			const imagesContainer = main.querySelector(".verticalGallery__images__container");
			const slides = main.querySelectorAll(".verticalGallery__images__image");
			const imgarray = Array.from(slides).map(image=>{
				return [image, image.querySelector("img")];
			});
			const progressbar = main.querySelector(".verticalGallery__bar__progress");
			const isWedding = document.body.classList.contains("wedding");
			ScrollTrigger.create({
				trigger: main,
				start: ()=>"center-="+(isWedding ? rpx(50) : 0)+" center",
				endTrigger: main,
				end: ()=>"center+="+(images.offsetHeight*(slides.length-1) - (isWedding ? rpx(50) : 0))+" center",
				pin: true,
				pinSpacing: false,
				onUpdate: self=>scrollOnUpdate(self)
			});

			const galleryTitleset = gallery.querySelector(".verticalGallery__titleset");
			if(galleryTitleset){
				const isLeftGallery = gallery.classList.contains("leftgallery");
				ScrollTrigger.create({
					trigger: galleryTitleset,
					start: ()=>"top top+="+((isWedding || isLeftGallery) ? rpx(100) : rpx(30)),
					endTrigger: main,
					end: ()=>"center+="+(images.offsetHeight*(slides.length-1) - (isWedding ? rpx(50) : 0))+" center",
					pin: true,
					pinSpacing: false
				});
			}

			const scrollOnUpdate = (self)=>{
				const scrollPosition = (images.offsetHeight*(slides.length-1))*self.progress;
				progressbar.style.transform = "scaleY("+self.progress+")";
				imagesContainer.style.transform = "translateY("+(scrollPosition*-1)+"px)";
				imgarray.forEach((img,i)=>{
					const initialPosition = i*images.offsetHeight;
					const unitProgress = Math.max(-1, Math.min(1, self.progress*(imgarray.length-1) - i));
					img[1].style.transform = "translateY("+(20*unitProgress)+"%)";
				});
			}
		}
		if(window.currentContext == "sp"){
			const links = gallery.querySelector(".restaurant__cuisine__menu, .verticalGallery__body__menu");
			if(links) gallery.append(links);

			const main = gallery.querySelector(".verticalGallery__contents");
			const images = main.querySelector(".verticalGallery__images");
			const imagesContainer = main.querySelector(".verticalGallery__images__container");
			const slides = main.querySelectorAll(".verticalGallery__images__image");
			const imgarray = Array.from(slides).map(image=>{
				return [image, image.querySelector("img")];
			});
			const progressbar = main.querySelector(".verticalGallery__bar__progress");
			const isWedding = document.body.classList.contains("wedding");
			const stickyReserveNav = document.querySelector(".stickyReserveNav");
			const titleset = gallery.querySelector(".verticalGallery__titleset");

			ScrollTrigger.create({
				trigger: titleset,
				start: ()=>"top-="+(rpx(15) + (isWedding ? rpx(110) : 0) )+" top",
				endTrigger: main,
				end: ()=>"center+="+(images.offsetHeight*(slides.length-1) + (isWedding ? rpx(-55) : 0) + (stickyReserveNav ? rpx(0) : 0) )+" center",
				pin: true,
				pinSpacing: false
			});
			ScrollTrigger.create({
				trigger: main,
				start: ()=>"center-="+((isWedding ? rpx(55) : 0) + (stickyReserveNav ? rpx(0) : 0))+" center",
				endTrigger: main,
				end: ()=>"center+="+(images.offsetHeight*(slides.length-1) + (isWedding ? rpx(-55) : 0) + (stickyReserveNav ? rpx(0) : 0) )+" center",
				pin: true,
				pinSpacing: false,
				onUpdate: self=>scrollOnUpdate(self)
			});
			setTimeout(()=>{
				window.dispatchEvent(new Event("resize"));
			}, 100);
			

			const scrollOnUpdate = (self)=>{
				const scrollPosition = (images.offsetHeight*(slides.length-1))*self.progress;
				progressbar.style.transform = "scaleY("+self.progress+")";
				imagesContainer.style.transform = "translateY("+(scrollPosition*-1)+"px)";
				imgarray.forEach((img,i)=>{
					const initialPosition = i*images.offsetHeight;
					const unitProgress = Math.max(-1, Math.min(1, self.progress*(imgarray.length-1) - i));
					img[1].style.transform = "translateY("+(20*unitProgress)+"%)";
				});
			}
		}
	}
}